import React, { useState, useEffect, useRef } from "react";
import WrongWhite from "../asset/WrongWhite.png";


function Modal({
  show,
  onClose,
  onSave,
  currentField,
  value,
  showAddModalOpen,
}) {
  const [inputValue, setInputValue] = useState(value);
  const textareaRef = useRef(null);
  console.log("inputValue", inputValue);

  useEffect(() => {
    setInputValue(value); // Update input value when modal opens or value changes
  }, [value]);
  useEffect(() => {
    if (textareaRef?.current) {
      textareaRef?.current.focus();
      textareaRef?.current.setSelectionRange(inputValue.length, inputValue.length); // Move cursor to the end
    }
  }, [inputValue]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          width: "70%",
          // height: "70vh",
          height: "auto",
          overflow: "scroll",
          scrollbarWidth: "none",
          borderRadius: "5px",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ position: "absolute", right: "18px", top: "10px" }}>
          <img
            onClick={onClose}
            src={WrongWhite}
            style={{
              backgroundColor: "black",
              height: "30px",
              width: "43px",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            alt="no-image"
          />
        </div>

        <h6 className="py-2">{currentField?.labelName}</h6>
        <textarea
          ref={textareaRef}
          autoFocus
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          style={{ height: "50vh", width: "100%" }}
          className="visitorAddCss py-2"
        />
        <div className="d-flex justify-content-lg-between align-items-center gap-2 pt-1">
          <button
            // onClick={onClose} // Close modal without saving
            style={{ backgroundColor: "red" }}
            type="button"
            className="btn btn-secondary w-25"
            onClick={() => {
              setInputValue("");
            }}
          >
            Delete
          </button>
          <button
            onClick={onClose} // Save the input value to form state
            type="button"
            className="btn btn-primary w-25"
          >
            Back
          </button>

          <button
            style={{ backgroundColor: "green" }}
            onClick={() => onSave(inputValue)} // Save the input value to form state
            type="button"
            className="btn btn-primary w-25"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
